class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.site-header');
    if (!this.header) return;

    this.threshold = 300;
    this.lastScrollY = window.scrollY;
    this.isSticky = false;
    this.isVisible = true;
    this.ticking = false;
    this.heroActive = false;

    this.sentinel = document.createElement('div');
    this.sentinel.style.height = '0px';
    this.sentinel.setAttribute('aria-hidden', 'true');
    this.after(this.sentinel);

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (document.body.dataset.heroPage === 'true') {
      this.heroActive = true;
      this.isSticky = true;
      this.isVisible = false;
      this.dataset.sticky = 'true';
      this.dataset.visible = 'false';
      this.setAttribute('aria-hidden', 'true');

      this.onHeroExited = () => {
        this.heroActive = false;
        this.isVisible = true;
        this.dataset.visible = 'true';
        this.removeAttribute('aria-hidden');
        this.lastScrollY = window.scrollY;
      };
      this.onHeroEntered = () => {
        this.heroActive = true;
        // Keep the bar revealed if the menu is open — its X is the close
        // control. onMenuClose re-hides it once the drawer closes.
        if (this.menuOpen) return;
        this.isVisible = false;
        this.dataset.visible = 'false';
        this.setAttribute('aria-hidden', 'true');
      };

      // On hero pages the bar is hidden, which also hides the drawer's close
      // (X) control. Reveal the bar while the menu is open so the X is visible
      // above the drawer (z-51 > z-50), then restore the hidden state on close.
      this.onMenuOpen = () => {
        this.menuOpen = true;
        if (!this.heroActive) return;
        this.isVisible = true;
        this.dataset.visible = 'true';
        this.removeAttribute('aria-hidden');
      };
      this.onMenuClose = () => {
        this.menuOpen = false;
        if (!this.heroActive) return;
        this.isVisible = false;
        this.dataset.visible = 'false';
        this.setAttribute('aria-hidden', 'true');
      };

      document.addEventListener('hero:exited', this.onHeroExited);
      document.addEventListener('hero:entered', this.onHeroEntered);
      document.addEventListener('mobile-menu:open', this.onMenuOpen);
      document.addEventListener('mobile-menu:close', this.onMenuClose);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.sentinel?.remove();
    if (this.onHeroExited) {
      document.removeEventListener('hero:exited', this.onHeroExited);
      document.removeEventListener('hero:entered', this.onHeroEntered);
      document.removeEventListener('mobile-menu:open', this.onMenuOpen);
      document.removeEventListener('mobile-menu:close', this.onMenuClose);
    }
  }

  onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  update() {
    if (this.heroActive) return;

    const scrollY = window.scrollY;
    const delta = scrollY - this.lastScrollY;
    if (Math.abs(delta) < 5) return;
    const scrollingDown = delta > 0;

    if (scrollY > this.threshold) {
      if (!this.isSticky) {
        this.isSticky = true;
        this.isVisible = false;
        this.header.style.transition = 'none';
        this.dataset.sticky = 'true';
        this.dataset.visible = 'false';
        this.header.offsetHeight;
        this.header.style.transition = '';
        this.sentinel.style.height = `${this.header.offsetHeight}px`;
        this.lastScrollY = scrollY;
        return;
      }

      if (scrollingDown && this.isVisible) {
        this.isVisible = false;
        this.dataset.visible = 'false';
      } else if (!scrollingDown && !this.isVisible) {
        this.isVisible = true;
        this.dataset.visible = 'true';
      }
    } else if (this.isSticky) {
      this.isSticky = false;
      this.isVisible = true;
      delete this.dataset.sticky;
      delete this.dataset.visible;
      this.sentinel.style.height = '0px';
    }

    this.lastScrollY = scrollY;
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
